import { createAsyncThunk } from '@reduxjs/toolkit';
import portalApi from '../../core/api/portal.api';
import { ParticipantSearchResponseFull, GraphQlError } from '../../core/types/common.types';
import { ParticipantSearchRequest, ParticipantSearchResponse } from './types';

export const participantSearchThunk = createAsyncThunk<
  // Return type of the payload creator
  ParticipantSearchResponse,
  // First argument to the payload creator
  ParticipantSearchRequest,
  // Types for ThunkAPI
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('participantSearch', async (values, thunkApi) => {
  const response: ParticipantSearchResponseFull = await portalApi.searchParticipants(values);
  const errors = response.errors;
  const participantResponse = response.data?.searchParticipants;

  if (errors) {
    return thunkApi.rejectWithValue(errors);
  }
  console.log(participantResponse);
  return participantResponse as ParticipantSearchResponse;
});
